module.exports = __webpack_public_path__ + "img/Desk Stationeryd25.2bd03b5c.jpg";